export type StepId =
  | "subjects"
  | "tutoring-options"
  | "tutor-profile"
  | "qualifications"
  | "contact-info"
  | "subscription"
  | "submit";

export type StepDefinition = {
  id: StepId;
  title: string;
  description?: string;
};

export const stepsConfig: StepDefinition[] = [
  { id: "subjects", title: "Subjects", description: "What can you teach?" },
  { id: "tutoring-options", title: "Lesson preferences", description: "Online / In person" },
  { id: "qualifications", title: "Credentials", description: "Your credentials" },
  { id: "contact-info", title: "Contact info", description: "Optional details" },
  { id: "tutor-profile", title: "Profile", description: "Title, bio, photo" },
  { id: "subscription", title: "Plan", description: "Plan & payment" },
  { id: "submit", title: "Submit", description: "Review & submit" },
];


